:host {
  --teaser-list-width: 480px;
  --meta-grid-template-areas: "filters search";
  --results-grid-template-areas: "map list";
}

.stzh-geo-ref-data {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 899;
  flex-direction: column;
  transition: opacity ease 0.2s;
  background-color: var(--stzh-color-white);

  // initially hidden
  display: none;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;

  &--is-open {
    display: flex;
    opacity: 1;
    visibility: visible;
    pointer-events: inherit;
  }

  &__header {
    display: none;

    @include mq($from: large) {
      display: inherit;
    }
  }

  &__content {
    overflow: hidden;
    height: 100%;
  }

  &--content-padding {
    padding-left: $containerMargin;
    padding-right: var(--stzh-space-medium);

    @include mq($from: small) {
      padding-left: $containerMarginSmall;
    }

    @include mq($from: medium) {
      padding-left: $containerMarginMedium;
    }

    @include mq($from: large) {
      padding-left: $containerMarginSmall;
    }
  }

  &__heading {
    display: flex;
    align-items: center;
    background-color: var(--stzh-color-secondary20);
    @include spaceCurve('padding-top', 'regular');
    @include spaceCurve('padding-bottom', 'regular');
  }

  /** Everything meta wrapper like search, filters etc. */

  &__meta-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: space(large);

    @include mq($to: large) {
      padding-top: space('medium');
      padding-bottom: space('medium');
    }

    @include spaceCurve('padding-top', 'small');
    @include spaceCurve('padding-bottom', 'small');

    @include mq($from: large) {
      display: grid;
      @include gridGutter;
      grid-template-areas: var(--meta-grid-template-areas);
      grid-template-columns: 1fr var(--teaser-list-width);
    }
  }

  &__filters {
    grid-area: filters;
    flex: none;
    margin-bottom: space(xxsmall);
  }

  &__filters-toggle {
    @include mq($from: large) {
      display: none;
    }
  }

  &__filters-toggle stzh-chip {
    @include mq($to: medium) {
      --icon-gap: 0;
    }
  }

  &__list-search {
    display: none;
    @include spaceCurve('padding-top', 'regular');
    @include spaceCurve('padding-bottom', 'regular');
  }

  &__filters-content {
    display: none;

    &--visible {
      padding: $containerMargin;

      @include mq($to: medium) {
        //padding: $containerMarginSmall;
      }

      @include mq($to: large) {
        display: flex;
        gap: space('xxlarge');
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: var(--stzh-color-white);
        //padding: $containerMarginMedium;
        z-index: 10;
        flex-direction: column;
        justify-content: space-between;
      }
    }

    @include mq($from: large) {
      display: block;
    }
  }

  &__filters-apply-button {
    display: block;

    @include mq($from: large) {
      display: none;
    }
  }

  &__search {
    grid-area: search;
    width: 100%;

    @include mq($from: large) {
      width: var(--teaser-list-width);
      padding-left: var(--stzh-space-medium);
      padding-right: var(--stzh-space-xsmall);
    }
  }

  &__search input {
    @include fontSize('milli');
  }

  &__results-toggle {
    grid-area: resultstoggle;
    flex: none;
    margin-bottom: space(xxsmall);

    @include mq($from: large) {
      display: none;
    }
  }

  /** Everything with results */

  &__results-wrapper {
    height: 100%;

    @include mq($from: large) {
      display: grid;
      @include gridGutter;
      grid-template-areas: var(--results-grid-template-areas);
      grid-template-columns: minmax(0, 1fr) var(--teaser-list-width);
    }
  }

  &__results-wrapper .inactive {
    @include mq($to: large) {
      visibility: hidden;
      height: 0;
      position: absolute;
      overflow: hidden;
    }
  }

  &__results-map {
    grid-area: map;
    position: relative;
    height: 100%;
  }

  &__map-controls {
    position: absolute;
    top: space(small);
    left: space(small);
    background-color: var(--stzh-color-white);
    padding: space(xsmall);
  }

  &__results-list {
    grid-area: list;
    padding-left: $containerMargin;
    padding-right: var(--stzh-space-medium);
    padding-bottom: space("xxlarge");
    overflow: auto;
    @include scrollbars;

    @include mq($from: small) {
      padding-left: $containerMarginSmall;
    }

    @include mq($from: medium) {
      padding-left: $containerMarginMedium;
    }

    @include mq($from: large) {
      width: var(--teaser-list-width);
      padding-left: 0;
      overflow: auto;
    }
  }

  &__results-list-heading {
    margin-bottom: var(--stzh-space-medium);
  }

  &__ol-map {
  }

  &__teaser-list {
    display: grid;
    gap: var(--stzh-space-medium);
    grid-template-columns: 1fr;

    @include mq($from: small) {
      grid-template-columns: 1fr 1fr;
    }

    @include mq($from: large) {
      grid-template-columns: 1fr;
    }
  }

  &__teaser-load-more {
    display: flex;
    justify-content: center;
    margin-top: space(medium);
  }

  /** no filters */

  &:not(&--has-filters) &__meta-wrapper {
    @include mq($from: large) {
      display: none;
    }
  }

  &:not(&--has-filters) &__filters {
    display: none;
  }

  &:not(&--has-filters) &__list-search {
    @include mq($from: large) {
      display: block;
    }
  }
}

.stzh-poi-teaser {
  display: flex;
  flex-direction: column-reverse;
  background-color: var(--stzh-color-grey10);
  position: relative;

  @include mq($from: large) {
    flex-direction: row;
    height: 180px;
  }

  &:hover {
    cursor: pointer;
    background-color: var(--stzh-color-secondary10);
  }

  &-content {
    padding: var(--stzh-space-medium);
    hyphens: auto;
    flex-grow: 1;

    stzh-heading {
      margin-bottom: space(xsmall);
      hyphens: auto;
    }

    stzh-text {
      --color: var(--stzh-color-grey80);
    }
  }

  &-link {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  &__image-wrapper {
    position: relative;
  }

  &__ratio {
    display: flex;
    height: 100%;
  }

  &__image-inner-wrapper {
    background-color: var(--stzh-color-grey20);
    position: absolute;
    inset: 0;
    height: 100%;
  }

  &__image-inner-wrapper img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &-list-item {
    display: flex;
    gap: space(small);
    margin-top: space(xxsmall);

    stzh-icon, stzh-text {
      --color: var(--stzh-color-grey80);
    }
  }
}
